import { Injectable } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { ExternalLinkPopUpDialogComponent, ExternalLinkPopUpDialogData, IdValuePairWithParentId, ServiceAddressWizardDialogComponent, ServiceAddressWizardDialogData, TylerSmartMeterTextEmailDialogComponent, TylerSmartMeterTextEmailDialogData } from "../components";

@Injectable()
export class UtilityBillingDialogService
{
    constructor(private readonly matDialog: MatDialog) { }

    showExternalLinkPopUpDialogOptions(url: string): Promise<boolean>
    {
        const dialogConfig: MatDialogConfig<ExternalLinkPopUpDialogData> = {
            data: {
                url
            }
        };
        const dialogRef = this.matDialog.open(ExternalLinkPopUpDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }

    showServiceAddressWizard(serviceAddressNumberMask: string): Promise<IdValuePairWithParentId>
    {
        const dialogConfig: MatDialogConfig<ServiceAddressWizardDialogData> = {
            data: {
                serviceAddressNumberMask
            }
        };
        const dialogRef = this.matDialog.open(ServiceAddressWizardDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }

    showTylerSmartMeterTextEmailDialog(
        accountNumber: string,
        landlordAccountNumber: string,
        alertId: string,
        email: string,
        sms: string,
        phone: string,
        landlordEmail: string,
        landlordSms: string,
        landlordPhone: string
    ): Promise<boolean>
    {
        const dialogConfig: MatDialogConfig<TylerSmartMeterTextEmailDialogData> = {
            data: {
                accountNumber,
                landlordAccountNumber,
                alertId,
                email,
                sms,
                phone,
                landlordEmail,
                landlordSms,
                landlordPhone
            }
        };
        const dialogRef = this.matDialog.open(TylerSmartMeterTextEmailDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }
}
